import React, { useState } from 'react';

function ProfilePage() {
  const [user, setUser] = useState({
    name: 'Jenna Muntz',
    email: 'jenna.muntz@example.com',
    phone: '(402) 123-4567',
    address: '123 Herding Lane, Pastureville',
    capabilities: 'Livestock Trailer, Tractor, First Aid Certified, Water Tank',
    profileImage: 'https://randomuser.me/api/portraits/women/32.jpg'
  });

  const [isEditing, setIsEditing] = useState(false);
  const [formData, setFormData] = useState({...user});

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setUser(formData);
    setIsEditing(false);
  };

  const handleImageUpload = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setFormData({ ...formData, profileImage: reader.result });
      };
      reader.readAsDataURL(file);
    }
  };

  return (
    <>
      <div className="account-header">
        <div className="profile-header-content">
          <div className="profile-image-container">
            <img 
              src={user.profileImage} 
              alt={user.name}
              className="profile-image"
            />
          </div>
          <div className="profile-header-text">
            <h2>Profile Information</h2>
          </div>
        </div>
        <button
          className="edit-button"
          onClick={() => setIsEditing(!isEditing)}
        >
          {isEditing ? 'Cancel' : 'Edit Profile'}
        </button>
      </div>

      {isEditing ? (
        <form onSubmit={handleSubmit} className="account-form">
          <div className="form-group">
            <label htmlFor="name">Name</label>
            <input
              type="text"
              id="name"
              name="name"
              value={formData.name}
              onChange={handleChange}
            />
          </div>

          <div className="form-group">
            <label htmlFor="email">Email</label>
            <input
              type="email"
              id="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
            />
          </div>

          <div className="form-group">
            <label htmlFor="phone">Phone</label>
            <input
              type="tel"
              id="phone"
              name="phone"
              value={formData.phone}
              onChange={handleChange}
            />
          </div>

         <div className="form-group">
            <label htmlFor="phone">Phone</label>
            <input
              type="tel"
              id="phone"
              name="phone"
              value={formData.phone}
              onChange={handleChange}
            />
          </div>

          <div className="form-group">
            <label htmlFor="address">Address</label>
            <input
              type="text"
              id="address"
              name="address"
              value={formData.address}
              onChange={handleChange}
            />
          </div>

          <div className="form-group">
            <label htmlFor="capabilities">Capabilities</label>
            <input
              type="text"
              id="capabilities"
              name="capabilities"
              placeholder="Comma separated (e.g., Livestock Trailer, Tractor, First Aid Certified)"
              value={formData.capabilities}
              onChange={handleChange}
            />
          </div>

          <div className="form-group">
            <label htmlFor="profileImage">Profile Picture</label>
            <input
              type="file"
              id="profileImage"
              name="profileImage"
              accept="image/*"
              onChange={handleImageUpload}
            />
          </div>

          <button type="submit" className="save-button">Save Changes</button>
        </form>
      ) : (
        <div className="account-details">
      

          <div className="detail-group">
            <span className="detail-label">Name:</span>
            <span className="detail-value">{user.name}</span>
          </div>

          <div className="detail-group">
            <span className="detail-label">Email:</span>
            <span className="detail-value">{user.email}</span>
          </div>

          <div className="detail-group">
            <span className="detail-label">Phone:</span>
            <span className="detail-value">{user.phone}</span>
          </div>

          <div className="detail-group">
            <span className="detail-label">Address:</span>
            <span className="detail-value">{user.address}</span>
          </div>

          <div className="detail-group">
            <span className="detail-label">Capabilities:</span>
            <span className="detail-value">{user.capabilities}</span>
          </div>
        </div>
      )}
    </>
  );
}

export default ProfilePage;
